import { render, staticRenderFns } from "./StoryStatusBar.vue?vue&type=template&id=1c2d50e4&scoped=true&"
import script from "./StoryStatusBar.vue?vue&type=script&lang=js&"
export * from "./StoryStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./StoryStatusBar.vue?vue&type=style&index=0&id=1c2d50e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d50e4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/StoryStatusBar.vue
// module id = 1043
// module chunks = 0